var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBGclassicnofade(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 403,
    height: 598,
    viewBox: "0 0 403 598",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M403 0H0V362H403V0Z",
    fill: "url(#paint0_linear_77_2)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_77_2",
    x1: -0.00000325162,
    y1: 3.02267,
    x2: 315.636,
    y2: 283.986,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "color-grad-1",
    stopColor: "#061BA4"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "color-grad-2",
    offset: 1,
    stopColor: "#2539C2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBGclassicnofade);
export default __webpack_public_path__ + "static/media/BGclassicnofade.d4580ec618fbb016bc4c43f16df00c6e.svg";
export { ForwardRef as ReactComponent };